module.exports = "<div class=\"container\" [title]=\"getTooltip()\" #Cont >\r\n    <input  class=\"input\" \r\n            (focusout)=\"focusOut(Input.value)\" \r\n            (keyup.enter)=\"focusOut(Input.value)\"\r\n            [(ngModel)]=\"value\" \r\n            placeholder=\"<NoTitle>\"\r\n            #Input>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input-title/input-title.component.html
// module id = ./src/app/shared/input-title/input-title.component.html
// module chunks = main